import { useState } from "react";
import { cn } from "../lib/utils";

interface RatingProps {
  value: number;
  onChange?: (value: number) => void;
  max?: number;
  size?: "sm" | "md" | "lg";
  readOnly?: boolean;
  className?: string;
}

export function Rating({
  value,
  onChange,
  max = 5,
  size = "md",
  readOnly = false,
  className = "",
}: RatingProps) {
  const [hovered, setHovered] = useState(0);
  const display = !readOnly && hovered > 0 ? hovered : value;

  return (
    <div
      className={cn("rating", `rating-${size}`, readOnly && "rating-readonly", className)}
      role={readOnly ? "img" : "group"}
      aria-label={`${value} out of ${max} stars`}
      onMouseLeave={() => setHovered(0)}
    >
      {Array.from({ length: max }, (_, i) => {
        const star = i + 1;
        return (
          <button
            key={star}
            type="button"
            className={cn("rating-star", star <= display && "rating-star-filled")}
            disabled={readOnly}
            onClick={() => onChange?.(star === value ? 0 : star)}
            onMouseEnter={() => !readOnly && setHovered(star)}
            aria-label={`${star} star${star !== 1 ? "s" : ""}`}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
            </svg>
          </button>
        );
      })}
    </div>
  );
}
